import ScrollMagic from 'scrollmagic';

export default {
    init() {
        if(jQuery('#header').length > 0) {
            var scrollcontrol = new ScrollMagic.Controller();
            var scrollscene = new ScrollMagic.Scene({
                triggerHook: 'onEnter',
                offset: 14
            }).addTo(scrollcontrol);
            scrollscene.setClassToggle('#header', 'is-scrolling');
            scrollscene.on('update', function(event) {
                let direction = scrollcontrol.info('scrollDirection');
                let offset = scrollscene.offset();
                let scrollPos = event.scrollPos;
            });
        }
    }
};

$('.header-search__close').click(function() {
    $('.header-search__container').animate({ width: 0 }, 'fast');
    $('.header-search__container').addClass('opacity-0');
    $('.menu-item').removeClass('hidden');
    return false;
});
$('.header-search__open').click(function() {
    $('.header-search__container').animate({ width: 18 + 'rem' }, 'slow');
    $('.header-search__container').animate({ opacity: 1 }, 'slow');
    $('.menu-item').addClass('hidden');
    return false;
});

if ($('.hamburger').hasClass('is-active')) {
    $('.cls-1').css({ fill: 'white' });
}

$('.open-dashboard-menu').click(function() {
    $('#dashboard-menu').slideToggle();
    $(this).toggleClass('dashboard-menu-active');
});
